export default {
  finance: 'Finance',
  plural: 'Settings',
  general: 'General',
  system: 'System',
  notification: 'Notifications',
  delete: 'Delete',
  deleteAccount: 'Delete account'
};
